import React from "react";
import { Container ,Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiVercel,
} from "react-icons/si";

function Toolstack() {


  return (
    <>
    <Container fluid className="home-about-section">
          <Container>
            <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
              <Col xs={4} md={2} className="tech-icons">
                <SiVisualstudiocode />
              </Col>
              <Col xs={4} md={2} className="tech-icons">
                <SiPostman />
              </Col>
              <Col xs={4} md={2} className="tech-icons">
                <SiSlack />
              </Col>
              <Col xs={4} md={2} className="tech-icons">
                <SiVercel />
              </Col>
            </Row>
        </Container>
    </Container>

    </>
  );
}

export default Toolstack;
